module.exports = {"abogalitypro":{"form":{"collegiateNumber":"Província de colegiado"},"cards":{"10":{"subtitle":"Entre em contato com outros advogados por meio de mensagens internas"},"19":{"title":"Interconsultas"},"video":{"title":"Plataforma de vídeo profissional","subtitle":"Seguro e privado. \nNão requer cadastro de usuários (Teams, Zoom...)"}}},"iva-not-included":"(IVA não incluído)"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/pt/public/views/abogalitypro.json
// module id = 627
// module chunks = 120